
export interface MainResponse{
    response_code:string;
    response_desc?: string;
    response_ref?: string;
}

export interface PayloadResponse<T> {
    state_code: string;
    description: string;
    data:T
}

export interface ApiResponse<T> extends MainResponse{
    payload?: PayloadResponse<T>
}


export enum ResponseStatus{
    SUCCESS = '40000',
    INTERNALERROR = '42002'
}